module.exports = __webpack_public_path__ + "img/116.7c524a4b.webp";